/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { PureComponent, Component, useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { connect, useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  Button,
  Divider,
  Form,
  Grid,
  Icon,
  Modal,
  Segment,
} from 'semantic-ui-react';

import {
  CustomTable,
  EmptyContainer,
  LocationSearchInput,
} from '../../../components';

import {
  CustomCheckbox,
  CustomDropdown,
  CustomInput,
} from '../../../components/form';

import {
  createOrgVenues,
  deleteOrgVenues,
  getOrgVenuesList,
  getOrgVenuesTypes,
  getVenueTypes,
  updateOrgVenues,
} from '../../../store/actions';

import {
  assign,
  compact,
  find,
  get,
  isEmpty,
  map,
  sortBy,
  uniq,
} from '../../../utils/lodash';

import {
  addVenueInitialValues,
  addVenueValidation,
} from '../../../validations/addVenueTypeValidation';

import { CheckboxComp } from '../../../components/form/checkboxes/checkBoxGroup';
import countries from 'i18n-iso-countries';
import { INSTANCE_DEFAULT_COUNTRY_CODE } from '../../../utils/instanceConstant';

import './organization.scss';

const VenueForm = (props) => {
  const { t, i18n } = useTranslation();
  const [venueTypesDescription, setVenueTypesDescription] = useState(null);
  const [venueTypesIsOnline, setVenueTypesIsOnline] = useState(false);
  const [isOwned, setIsOwned] = useState(false);
  const [initialValues, setInitialValues] = useState(
    addVenueInitialValues({
      ...props.venue,
      country:
        get(props, 'venue.country') ||
        get(props, 'organization.organization.country') ||
        INSTANCE_DEFAULT_COUNTRY_CODE,
    })
  );

  const [selectedOption, setSelectedOptions] = useState([]);

  const dispatch = useDispatch();

  const { orgVenueTypes } = useSelector((state) => state.extra);
  const [subOptions, setSubOptions] = useState([]);
  const loading = useSelector((state) => state.organization.loading);
  const auth = useSelector((state) => state.authentication);

  useEffect(() => {
    const { venue } = props;
    setVenueTypesDescription(get(venue, 'venueType.description'));
    setVenueTypesIsOnline(get(venue, 'venueType.isOnline'));

    setSubOptions(get(venue, 'venueType.option', []));
    if (venue && venue.owned === 1) {
      setIsOwned(true);
    } else {
      setIsOwned(false);
    }
  }, []);

  const handleValidSubmit = async (values, resetForm) => {
    try {
      const { isNew, toggle, projectId, resetPage, activity = {} } = props;
      const form = {};
      delete values.isOwned;

      assign(form, values);
      isOwned ? (form.owned = true) : (form.owned = false);

      const currentActivityId = get(activity, 'currentActivity.id', null);

      form.activityId = currentActivityId;

      values.organisationId && delete values.organisationId;
      values.createdBy && delete values.createdBy;

      form.subVenueOptions = selectedOption;
      if (venueTypesIsOnline) {
        delete form.country;
        delete form.streetAddress;
        delete form.streetAddress2;
        delete form.suburb;
        delete form.state;
        delete form.postCode;
      }
      if (isNew) {
        const isSubmitted = await dispatch(createOrgVenues(form, projectId));
        if (resetPage) resetPage();
        if (isSubmitted) {
          toggle();
          resetForm();
        }
      } else {
        const { venue } = props;
        const isSubmitted = await dispatch(
          updateOrgVenues(venue.id, form, projectId)
        );
        if (isSubmitted) {
          toggle();
          resetForm();
        }

        if (resetPage) resetPage();
      }
    } catch (error) {
      console.error('VenueForm ~ handleValidSubmit ~ error', error);
    }
  };

  const setLocations = (data, values) => {
    const addressNo = get(data, 'streetNumber');
    const addressLine = get(data, 'streetAddress');

    const locationsValue = {
      venueTypeId: values.venueTypeId ? values.venueTypeId : '',
      name: values.name ? values.name : '',
      country: data.country || '',
      streetAddress:
        addressNo && addressLine
          ? addressNo.concat(', ', addressLine)
          : addressNo || addressLine,
      streetAddress2: '',
      suburb: data.suburb ? data.suburb : '',
      state: data.state ? data.state : '',
      postCode: data.postcode ? data.postcode : '',
    };

    data.business_status && data.name
      ? (locationsValue.name = data.name)
      : (locationsValue.name = '');
    setInitialValues({ ...initialValues, ...locationsValue });
  };

  const onChangeIsOwned = () => {
    setIsOwned(!isOwned);
  };

  const renderVenueTypes = () => {
    if (isEmpty(orgVenueTypes)) return null;
    let venues = sortBy(orgVenueTypes, 'name');
    // Filter out venues where isNotVisible is true
    venues = venues.filter((venue) => !venue.isNotVisible);
    return compact(
      map(venues, (venue, key) => {
        return {
          key,
          text: venue.name,
          value: venue.id,
        };
      })
    );
  };

  const renderCountries = () => {
    const currentLanguage = i18n.language || 'en';
    const countryObj = countries.getNames(currentLanguage, { select: 'alias' });

    return Object.entries(countryObj).map(([code, name]) => ({
      key: code,
      text: name,
      value: code,
    }));
  };

  const changeVenueType = (value) => {
    const venues = find(orgVenueTypes, (item) => item.id === value);
    const isOnline = find(
      orgVenueTypes,
      (item) => item.id === value && item.isOnline === true
    );
    setVenueTypesIsOnline(isOnline ? true : false);
    setVenueTypesDescription(get(venues, 'description'));
    let subOptions = venues.venueSubOptions;
    subOptions = map(subOptions, (item) => {
      return {
        ...item,
        label: item.name,
        value: item.id,
        checked: false,
      };
    });
    setSubOptions(subOptions);
    //reset sub values
    setSelectedOptions([]);
  };

  const handleChangeOptions = (value, check) => {
    const newValue = parseInt(value);
    let _selectedOption = [...selectedOption];

    var index = _selectedOption.indexOf(newValue);

    if (check === true) {
      _selectedOption.push(newValue);
      setSelectedOptions(uniq(_selectedOption));
    } else {
      if (index > -1) {
        _selectedOption.splice(index, 1);
      }

      _selectedOption = uniq(_selectedOption);
      setSelectedOptions(_selectedOption);
    }
  };

  return (
    <Formik
      enableReinitialize
      onSubmit={(values, { resetForm }) => {
        handleValidSubmit(values, resetForm);
      }}
      initialValues={initialValues}
      validationSchema={
        venueTypesIsOnline
          ? addVenueValidation(t, true)
          : addVenueValidation(t, false)
      }
    >
      {({ values, handleSubmit, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <div className="form-content">
            {!venueTypesIsOnline ? (
              <>
                <div className="formik-custom-field-margin-top-zero">
                  <CustomDropdown
                    search
                    name="country"
                    id="country"
                    labelText={t('formulary.country')}
                    placeholder={t('formulary.placeholder.select_country')}
                    options={renderCountries()}
                    requiredStar
                  />
                </div>

                <LocationSearchInput
                  label={t('formulary.search_venue')}
                  placeHolder={t('formulary.placeholder.enter_venue_name')}
                  customClass="org-inputs-location-search-venue"
                  className="org-inputs-location-search-venue"
                  country={values.country}
                  getLocation={(data) => setLocations(data, values)}
                />
              </>
            ) : null}
            <div className="venue-type">
              <CustomDropdown
                name="venueTypeId"
                id="venueTypeId"
                labelText={t('formulary.venue_type')}
                placeholder={t('formulary.placeholder.select_venue_type')}
                options={renderVenueTypes()}
                getValue={(value) => [
                  changeVenueType(value),
                  setFieldValue('subVenueOptions', []),
                ]}
                requiredStar
              />
              {venueTypesDescription ? (
                <label className="venue-type-des">
                  {venueTypesDescription}
                </label>
              ) : null}
            </div>

            {!isEmpty(subOptions) && (
              <CheckboxComp
                options={subOptions}
                id="subVenueOptions"
                name="subVenueOptions"
                setFieldValue={setFieldValue}
                getValue={(e) => {
                  handleChangeOptions(e.target.value, e.target.checked);
                }}
              />
            )}

            <CustomInput
              id="name"
              name="name"
              placeholder={t('formulary.placeholder.enter_venue_name')}
              labelText={t('formulary.venue_name')}
              requiredStar
            />

            {!venueTypesIsOnline ? (
              <>
                <CustomInput
                  id="streetAddress"
                  name="streetAddress"
                  placeholder={t('formulary.placeholder.enter_address_line_1')}
                  labelText={t('formulary.address_line_1')}
                  requiredStar
                />

                <CustomInput
                  id="streetAddress2"
                  name="streetAddress2"
                  placeholder={t('formulary.placeholder.enter_address_line_2')}
                  labelText={t('formulary.address_line_2')}
                />

                <div className="venue-address-grid">
                  <div className="venue-address-item">
                    <CustomInput
                      id="suburb"
                      name="suburb"
                      placeholder={t('formulary.placeholder.enter_suburb')}
                      labelText={t('formulary.suburb')}
                      requiredStar
                    />
                  </div>

                  <div className="venue-address-item">
                    <CustomInput
                      id="state"
                      name="state"
                      placeholder={t('formulary.placeholder.enter_state')}
                      labelText={t('formulary.state_province')}
                      requiredStar
                    />
                  </div>

                  <div className="venue-address-item">
                    <CustomInput
                      id="postCode"
                      name="postCode"
                      placeholder={t('formulary.placeholder.enter_postcode')}
                      labelText={t('formulary.postcode')}
                      requiredStar
                    />
                  </div>
                </div>

                <CustomCheckbox
                  id="isOwned"
                  name="isOwned"
                  label={t('organisation.venues.this_venue_is_owned_by', {
                    org:
                      auth.user.organisation && auth.user.organisation.name
                        ? auth.user.organisation.name
                        : t('common.organisation').toLowerCase(),
                  })}
                  checked={isOwned}
                  className="check-box"
                  onChange={() => onChangeIsOwned()}
                />
              </>
            ) : null}
          </div>

          <Divider section />
          <div className="venue-modal-buttons">
            <Button
              disabled={loading}
              loading={loading}
              content={
                props.isNew
                  ? t('specific_actions.add_venue')
                  : t('actions.save_changes')
              }
              size="small"
              className="Primary-Button"
              type="submit"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

class VenueDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async handleGoalDelete() {
    const { auth, venue, deleteOrgVenues, resetPage } = this.props;
    const orgId = auth.user.organisation ? auth.user.organisation.id : null;
    await deleteOrgVenues(orgId, venue.id);
    if (resetPage) resetPage();
    this.toggle();
  }

  render() {
    const { modal } = this.state;
    const { t, venue, loading } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClose={() => this.toggle()}
        size="mini"
        trigger={
          <label className="org-users-actions-error first-down">
            {t('actions.remove')}
          </label>
        }
        className="delete-venue"
      >
        <Modal.Header className="modal-header-font">
          {t('organisation.venues.delete_venue_header', { name: venue.name })}
        </Modal.Header>
        <Modal.Content>
          <p>{t('organisation.venues.delete_venue_confirm_text')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => this.toggle()}
            className="Secondary-Button"
            loading={loading}
            disabled={loading}
          >
            {t('actions.no')}
          </Button>
          <Button
            onClick={() => this.handleGoalDelete()}
            className="Primary-Button"
            content={t('actions.yes')}
            loading={loading}
            disabled={loading}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export class VenueUpdate extends PureComponent {
  //---------------------------------this component is used in Activity Plan UI-------------
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t, venue } = this.props;

    return (
      <div className="add-user">
        <Modal
          trigger={
            <label className="org-users-actions-warn  first-down default-color">
              {t('actions.edit')}
            </label>
          }
          size="tiny"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <div
              className="new-activity-modal-close-icon"
              onClick={() => this.toggle()}
            >
              &times;
            </div>
          }
          className="update-Venue"
        >
          <Modal.Header className="modal-header-font">
            {t('organisation.venues.venue_update_header', { name: venue.name })}
          </Modal.Header>
          <Modal.Content>
            <VenueForm
              toggle={() => this.toggle()}
              {...this.props}
              isNew={false}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class VenueCreateComponent extends PureComponent {
  //-------------this component is used in Activity Plan UI-------------
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t, projectId } = this.props;

    return (
      <div className="add-user">
        <Modal
          className="add-new-venue"
          trigger={
            <Button
              className={projectId ? 'Secondary-Button' : 'Primary-Button'}
            >
              <Icon name="plus" />
              {t('organisation.venues.add_new_venue')}
            </Button>
          }
          size="tiny"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <div
              className="new-activity-modal-close-icon"
              onClick={() => this.toggle()}
            >
              &times;
            </div>
          }
        >
          <Modal.Header className="modal-header-font">
            {t('organisation.venues.add_new_venue')}
          </Modal.Header>
          <Modal.Content>
            <VenueForm
              toggle={() => this.toggle()}
              {...this.props}
              isNew={true}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class OrganizationVenues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  resetPage() {
    this.setState({
      currentPage: 1,
    });
  }

  columns() {
    const { t } = this.props;

    return [
      {
        title: t('formulary.venue_type'),
        width: '7',
        render: (data) => {
          return (
            <div className="org-users-container">
              <label>{data.name}</label>
              <label className="org-users-text">
                {data.venueType ? data.venueType.name || '-' : '-'}
              </label>
            </div>
          );
        },
      },
      {
        title: t('formulary.suburb'),
        width: '5',
        render: (data) => {
          return <label>{data.suburb || '-'}</label>;
        },
      },
      {
        title: '',
        width: '3',
        render: (data) => {
          return (
            <div className="org-users-actions">
              <VenueUpdate
                venue={data}
                resetPage={() => this.resetPage()}
                {...this.props}
              />
              <VenueDelete
                venue={data}
                resetPage={() => this.resetPage()}
                {...this.props}
              />
            </div>
          );
        },
      },
    ];
  }

  async componentDidMount() {
    const { currentPage } = this.state;
    const { auth, getOrgVenuesList, getOrgVenuesTypes, getVenueTypes } =
      this.props;
    getOrgVenuesTypes();
    getVenueTypes();
    if (!isEmpty(auth.user) && auth.user.organisation) {
      getOrgVenuesList(currentPage);
    }
  }

  pageChange(page) {
    const { auth, getOrgVenuesList } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        if (!isEmpty(auth.user) && auth.user.organisation) {
          getOrgVenuesList(page);
        }
      }
    );
  }

  render() {
    const { t } = this.props;
    const { orgVenues, loading } = this.props.organization;
    const { currentPage } = this.state;

    return (
      <Segment className="content-segment org-users" loading={loading}>
        <Grid>
          <Grid.Row className="add-venue-org-row">
            <Grid.Column
              mobile={16}
              tablet={16}
              computer={16}
              textAlign="right"
            >
              <VenueCreate {...this.props} resetPage={() => this.resetPage()} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {orgVenues.docs && orgVenues.docs.length ? (
          <div className="org-table-container">
            <CustomTable
              header
              columns={this.columns()}
              data={orgVenues.docs}
              customClass="org-users-table"
              pagination
              handlePaginationChange={(page) => this.pageChange(page)}
              page={currentPage}
              noOfPages={orgVenues.pages}
              keyExtractor={(item, index) => item.id}
            />
          </div>
        ) : (
          <EmptyContainer msg={t('organisation.venues.no_venues_added')} />
        )}
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
    extra: state.extra,
    venueTypes: state.extra.venueTypes,
    loading: state.organization.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOrgVenuesList,
      getOrgVenuesTypes,
      deleteOrgVenues,
      getVenueTypes,
    },
    dispatch
  );
};

OrganizationVenues = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(OrganizationVenues));

export const VenueCreate = withTranslation()(VenueCreateComponent);

export { OrganizationVenues };
